import { render, staticRenderFns } from "./WindIcon.vue?vue&type=template&id=7a31a708&scoped=true&"
import script from "./WindIcon.vue?vue&type=script&lang=js&"
export * from "./WindIcon.vue?vue&type=script&lang=js&"
import style0 from "./WindIcon.vue?vue&type=style&index=0&id=7a31a708&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a31a708",
  null
  
)

export default component.exports